import FieldHintArrow from '@/assets/icons/field-hint-arrow.svg';

interface IProps {
    isActive: boolean;
    name: string;
    value: string;
    testId?: string;
    className?: string;
    arrowDirection?: 'up' | 'left' | 'right';
};

export const HintFieldSkeletron = ({ testId = 'base-hint-field-skeleton', isActive, className, name, value, arrowDirection = 'right' }: IProps) => {
    const arrowDirectionMap = {
        right: 'bottom-0 right-0 rotate-[70deg] translate-y-[15%] translate-x-[160%]',
        left: 'bottom-0 left-0 rotate-[-70deg] scale-x-[-1] translate-y-[15%] translate-x-[-160%]',
        up: 'top-0 right-0 translate-x-[20%] translate-y-[-120%]',
    };

    return (
        <p data-testid={testId} className={`${className || ''} font-atkinsonHyperlegible relative sm-max:text-[14px] after:absolute after:w-[112%] after:h-[140%] after:left-[-6%] after:top-[-20%] after:transition after:duration-500 after:z-0 after:rounded-[1px] ${isActive ? 'after:bg-aqua-300' : ''}`}>
            <img className={`transition duration-500 ${isActive ? '' : 'opacity-0'} absolute ${arrowDirectionMap[arrowDirection]}`} width={50} src={FieldHintArrow} alt="field hint" />
            <span data-testid={`${testId}-name`} className="font-bold relative z-10">{name}:</span> <span className="relative z-10" data-testid={`${testId}-value`}>{value}</span>
        </p>
    );
};